/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Btn_Submit_RequestInputs */

const es_cap_btn_submit_request = /** @type {(inputs: Cap_Btn_Submit_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar solicitud`)
};

const gl_cap_btn_submit_request = /** @type {(inputs: Cap_Btn_Submit_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar solicitude`)
};

const en_cap_btn_submit_request = /** @type {(inputs: Cap_Btn_Submit_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit request`)
};

/**
* | output |
* | --- |
* | "Submit request" |
*
* @param {Cap_Btn_Submit_RequestInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_btn_submit_request = /** @type {((inputs?: Cap_Btn_Submit_RequestInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Btn_Submit_RequestInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_btn_submit_request(inputs)
	if (locale === "en") return en_cap_btn_submit_request(inputs)
	return es_cap_btn_submit_request(inputs)
});